import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import PageWrapper from '../../componenti/PageWrapper';
import PageContent from '../../componenti/PageContent';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/admin/dashboard'); 
    } catch (err) {
      setError(err.message || 'Credenziali non valide o errore di connessione.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrapper>
      <PageContent title="Area Amministratore">
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <Box 
          sx={{ 
            width: '100%',
            maxWidth: 400, 
            mt: 4, 
            p: 3, 
            boxShadow: 3, 
            borderRadius: 2,
            bgcolor: 'background.paper'
          }}
        >
          <Typography variant="h6" align="center" gutterBottom>
            Accedi al Pannello
          </Typography>
          
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Username"
              type="text"
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Button
              fullWidth
              type="submit"
              variant="contained"
              color="primary"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? 'Accesso in corso...' : 'Entra'}
            </Button>
          </form>
        </Box>
        </Box>
      </PageContent>
    </PageWrapper>
  );
}
